export default __webpack_public_path__ + "static/media/img9.feb3a26a.jpeg";